import DashboardConfiguration from 'components/DynamicDashboard/DashboardConfiguration';
import i18n from 'i18n';
import React from 'react';
import { useClientsDashboard } from './useClientsDashboard';

interface ClientsDashboardConfigurationProps {
  filters: Record<string, string>;
  selectedCards: string[];
  setSelectedCards: React.Dispatch<React.SetStateAction<string[]>>;
}

const ClientsDashboardConfiguration = ({
  filters,
  selectedCards,
  setSelectedCards,
}: ClientsDashboardConfigurationProps) => {
  const dashboardProps = useClientsDashboard({ filters });

  return (
    <DashboardConfiguration
      disableDashboardText={i18n.t('DONT_USE_CLIENTS_DASHBOARD_KEY')}
      selectedCards={selectedCards}
      setSelectedCards={setSelectedCards}
      {...dashboardProps}
    />
  );
};

export default ClientsDashboardConfiguration;
